import { TRANSLATIONS_AUTH } from '../translations/auth';

export const COLLABORATOR_DETAIL_ROUTE = '/collaborator/details';
export const COLLABORATORS_ROUTE = '/collaborators';
export const COLLABORATORS_MANAGEMENT_ROUTE = '/collaborators/management';
export const COLLABORATORS_HOME_ROUTE = '/collaborators/home';
export const METRICS_NE_ROUTE = '/betterfly-effect/metrics';
export const HOME_ROUTE = '/home';
export const LOGIN_ROUTE = '/login';
export const SETTINGS_ROUTE = '/settings';
export const INTEGRATIONS_ROUTE = '/settings/integrations';
export const NEW_CHANGE_ORGANIZATION_ROUTE = '/settings/organization-ne';
export const ACCOUNT_ROUTE = '/settings/account';
export const PLAN_ROUTE = '/plan';
export const RESET_PASSWORD_ROUTE = '/reset-password';
export const SIGN_UP_ROUTE = '/sign-up';
export const MICROSOFT_SIGN_UP_ROUTE = '/microsoft-sign-up';
export const LOGIN_SSO_ROUTE = '/login-sso';
export const STORIES_ROUTE = '/stories/list';
export const NEW_STORY_ROUTE = '/stories/new';
export const LOAD_BALANCE_ROUTE = '/rewards/load-balance';
export const REWARDS_POINTS_ROUTE = '/rewards/points';
export const REWARDS_POINTS_CONFIG_ROUTE = '/rewards/points-config';
export const REWARDS_POINTS_FILE_ROUTE = '/rewards/points-file';
export const REWARDS_HISTORY_DETAILS_ROUTE = '/rewards/history-details';
export const REWARDS_HISTORY_ROUTE = '/rewards/history';
export const CHALLENGES_MAIN_ROUTE = '/challenges/main';
export const CREATE_CHALLENGE_ROUTE = '/challenges/create';
export const MANAGE_COLLABORATORS_ROUTE = '/manage-collaborators';
export const DELETE_COLLABORATORS_ROUTE = '/manage-collaborators/delete';
export const ADD_COLLABORATORS_ROUTE = '/manage-collaborators/subscribe';
export const COLLABORATORS_ADD_DEPENDENTS_ROUTE = '/manage-collaborators/add-dependents';
export const BENEFIT_DETAIL_ROUTE = '/benefit-detail';
export const INSURANCE_DETAIL_ROUTE = '/insurance-detail';
export const BENEFITS_TO_CHOOSE_ROUTE = '/plan/benefits-to-choose';
export const BALANCE_CHARGE_ROUTE = '/flexible-remuneration/balance-charge';
export const REPORTS_ROUTE = '/reports';
export const LANDING_HEALTH_REPORT_ROUTE = '/reports/health';
export const REQUEST_TABLE_ROUTE = '/requests';
export const REQUEST_DETAIL_ROUTE = '/requests/detail';

export const AUTH_ROUTES: string[] = [LOGIN_ROUTE, SIGN_UP_ROUTE, RESET_PASSWORD_ROUTE, LOGIN_SSO_ROUTE];

export const APP_ROUTES: string[] = [
  HOME_ROUTE,
  METRICS_NE_ROUTE,
  COLLABORATORS_ROUTE,
  COLLABORATOR_DETAIL_ROUTE,
  COLLABORATORS_MANAGEMENT_ROUTE,
  COLLABORATORS_HOME_ROUTE,
  SETTINGS_ROUTE,
  PLAN_ROUTE,
  INTEGRATIONS_ROUTE,
  ACCOUNT_ROUTE,
  NEW_CHANGE_ORGANIZATION_ROUTE,
  STORIES_ROUTE,
  NEW_STORY_ROUTE,
  LOAD_BALANCE_ROUTE,
  REWARDS_POINTS_ROUTE,
  REWARDS_POINTS_CONFIG_ROUTE,
  REWARDS_POINTS_FILE_ROUTE,
  REWARDS_HISTORY_DETAILS_ROUTE,
  REWARDS_HISTORY_ROUTE,
  CHALLENGES_MAIN_ROUTE,
  CREATE_CHALLENGE_ROUTE,
  MANAGE_COLLABORATORS_ROUTE,
  BENEFIT_DETAIL_ROUTE,
  INSURANCE_DETAIL_ROUTE,
  BALANCE_CHARGE_ROUTE,
  REPORTS_ROUTE,
  DELETE_COLLABORATORS_ROUTE,
  ADD_COLLABORATORS_ROUTE,
  COLLABORATORS_ADD_DEPENDENTS_ROUTE,
  LANDING_HEALTH_REPORT_ROUTE,
  REQUEST_TABLE_ROUTE,
  REQUEST_DETAIL_ROUTE,
  INSURANCE_DETAIL_ROUTE,
  BENEFITS_TO_CHOOSE_ROUTE
];

export const EMPTY_COMPANY_ROUTES = [
  HOME_ROUTE,
  SETTINGS_ROUTE,
  ACCOUNT_ROUTE,
  NEW_CHANGE_ORGANIZATION_ROUTE,
  INTEGRATIONS_ROUTE,
  PLAN_ROUTE,
  BENEFIT_DETAIL_ROUTE,
  INSURANCE_DETAIL_ROUTE,
  BENEFITS_TO_CHOOSE_ROUTE
];

export const NO_LAYOUT_ROUTES = [LANDING_HEALTH_REPORT_ROUTE];
export const NO_FOOTER_ROUTES = [REQUEST_DETAIL_ROUTE];

export const SEND_CODE_COUNTDOWN = 180;

export const SESSION_INACTIVITY_TIMEOUT = 1000 * 60 * 15; // mills * seconds * minutes

export const TEXT_FIELDS = {
  temporalInput: 'temporal',
  passwordInput: 'password',
  confirmInput: 'confirm',
  currentInput: 'current'
};

export const SESSION_COOKIES_TIMEOUT = 1 / 24 / 2; // days / hours / half hour
export const BTF_DOMAIN = process.env.VITE_BTF_DOMAIN;

export const LOGIN_PROVIDER_NAME = 'provider';
export const LOGIN_PROVIDER_GOOGLE = 'google';
export const LOGIN_PROVIDER_MICROSOFT = 'microsoft';
export const LOGIN_PROVIDER_CREDENTIALS = 'credentials';
export const LOGIN_PROVIDER_CLIENTS_PORTAL = 'clientsPortal';
export const LOGIN_GOOGLE_PRIVACY_POLICY = 'https://policies.google.com/privacy';
export const LOGIN_GOOGLE_TERMS_AND_CONDITIONS = 'https://policies.google.com/terms';

export const LOWER_CHARS = 'abcdefghijklmnopqrstuvwxyz';
export const NUMBER_CHARS = '0123456789';
export const SPECIAL_CHARS = '^$*.[]{}()?-!@#%&/,><:;|_~+=';

export const FIREBASE_MICROSOFT = 'microsoft.com';

export const DEEPLINK_URL_PARAM = 'deepLink';

export const MODE_CONFIG = {
  'create-account': {
    length: 12,
    pattern: /^[a-zA-Z0-9]*$/
  },
  'password-reset': {
    length: 6,
    pattern: /^[0-9]*$/
  },
  errorMessage: TRANSLATIONS_AUTH.verificationCode.codeInput.errorFormat
} as const;

export const ACCESS_INSTRUCTIONS_PAGE =
  'https://intercom.help/betterfly-support/es/articles/8725673-accede-por-primera-vez-al-portal-de-clientes';

export const SECONDARY_FLOW_PARENT_ROUTES: Record<string, string> = {
  [COLLABORATOR_DETAIL_ROUTE]: COLLABORATORS_HOME_ROUTE,
  [COLLABORATORS_ADD_DEPENDENTS_ROUTE]: COLLABORATORS_HOME_ROUTE,
  [ADD_COLLABORATORS_ROUTE]: MANAGE_COLLABORATORS_ROUTE,
  [DELETE_COLLABORATORS_ROUTE]: MANAGE_COLLABORATORS_ROUTE,
  [CREATE_CHALLENGE_ROUTE]: CHALLENGES_MAIN_ROUTE,
  [NEW_STORY_ROUTE]: STORIES_ROUTE,
  [LOAD_BALANCE_ROUTE]: HOME_ROUTE,
  [REWARDS_POINTS_FILE_ROUTE]: HOME_ROUTE,
  [REWARDS_POINTS_CONFIG_ROUTE]: REWARDS_POINTS_ROUTE,
  [REWARDS_HISTORY_DETAILS_ROUTE]: REWARDS_HISTORY_ROUTE,
  [BALANCE_CHARGE_ROUTE]: HOME_ROUTE,
  [BENEFIT_DETAIL_ROUTE]: PLAN_ROUTE,
  [INSURANCE_DETAIL_ROUTE]: PLAN_ROUTE,
  [BENEFITS_TO_CHOOSE_ROUTE]: PLAN_ROUTE,
  [REQUEST_DETAIL_ROUTE]: REQUEST_TABLE_ROUTE
};
